module.exports = __webpack_public_path__ + "src/assets/img/product-low-ph.8d6e9bef.png";